export default {
  DpScoringStatus: {
    scoringStatus: 'Scoring Status',
    score: 'Score',
    scored: 'Scored',
    partially_scored: 'Partially Scored',
    submitted: 'Submitted'
  }
};